import PropTypes from 'prop-types';
import React from 'react';
import { CheckLg } from 'react-bootstrap-icons';

import useTranslation from '../../hooks/use_translation';
import Trans from '../translation/trans';
import Link from './link';

const Included = ({ product_settings, size = 'md' }) => {
	const { t } = useTranslation('component_included');

	//	const sizes = [{ lg: 'lg', md: 'md', sm: 'sm' }];

	const variants = [
		{
			className: 'bio-age-badge',
			component: Link,
			icon: <CheckLg />,
			key: 'include_biological_age',
			labelKey: 't2',
			to: '#bio_age',
		},
		{
			className: '',
			component: 'div',
			icon: <CheckLg />,
			key: 'include_statement',
			labelKey: 't1',
		},
	];

	return (
		<div className="included-badges d-flex gap-2 flex-wrap">
			{variants.map((variant, index) => {
				const showFeature = product_settings && product_settings[variant.key];

				if (!showFeature) return null;

				const Component = variant.component || 'div';

				return (
					<Component
						className={`included-badge included-badge-${size} ${variant.className}`}
						key={index}
						{...(Component === Link ? { to: variant.to } : {})}
					>
						{variant.icon} <Trans i18nKey={variant.labelKey} t={t} />
					</Component>
				);
			})}
		</div>
	);
};

Included.propTypes = {
	product_settings: PropTypes.object,
	size: PropTypes.string,
};

export default Included;
